import { colors, clippath, borders, clippathleft } from '../cssVariables'

export const Button = {
  baseStyle: {
    cursor: 'pointer',
    fontWeight: '700',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'uppercase',
    transition: 'color 0.3s, background-color 0.3s',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    clipPath: clippath.polygon,
    borderRadius: 0,
  },
  sizes: {
    xs: {
      height: '20px',
      paddingInline: '6px',
    },
    sm: {
      minHeight: '36px',
      minWidth: '100px',
    },
    md: {
      minHeight: '48px',
      minWidth: '180px',
    },
    lg: {
      minHeight: '60px',
      minWidth: '140px',
    },
  },
  variants: {
    round: {
      background: colors.colorB5,
      color: colors.colorB1,
      borderRaduis: '6px',
      _hover: {
        background: colors.hoverColor4,
      },
    },
    solid: {
      background: colors.colorA1,
      color: colors.colorB7,
      _hover: {
        background: colors.colorA1Alpha80,
      },
      _active: {
        background: colors.colorA1Alpha80,
      },
      '&:disabled': {
        opacity: '0.4',
        background: colors.colorA1,
      },
    },
    greenSolid: {
      background: colors.colorA2,
      color: colors.colorB7,

      '&:disabled': {
        opacity: '0.4',

        _hover: {
          opacity: 0.4,
          background: colors.colorA2,
          color: colors.colorB7,
        },
      },
    },
    greenOutline: {
      pos: 'relative',
      background: colors.colorA2Alpha10,
      border: borders.outlineButton,
      color: colors.colorA2,
      // Use pseudo-element for border
      _after: {
        content: '""',
        position: 'absolute',
        right: '0',
        bottom: '0',
        // follow the polygon setting
        width: '6%',
        height: '30%',
        backgroundColor: colors.colorA2,
        clipPath: 'polygon(0 100%, 100% 0, 100% 100%)',
        pointerEvents: 'none',
      },
      _hover: {
        color: colors.colorB7,
        background: colors.colorA2,
      },
      _active: {
        background: colors.colorA2,
        color: colors.colorB7,
      },
      '&:disabled': {
        opacity: '0.4',
        background: colors.colorA2Alpha10,

        _hover: {
          color: colors.colorA2,
          background: colors.colorA2Alpha10,
        },
      },
    },
    grayOutline: {
      pos: 'relative',
      // background: colors.colorB3,
      border: `1px solid ${colors.colorB4}`,
      color: colors.colorB1,
      // Use pseudo-element for border
      _after: {
        content: '""',
        position: 'absolute',
        right: '0',
        bottom: '0',
        // follow the polygon setting
        width: '6%',
        height: '30%',
        backgroundColor: colors.colorB4,
        clipPath: 'polygon(0 100%, 100% 0, 100% 100%)',
        pointerEvents: 'none',
      },
      _hover: {
        background: colors.colorB4,
      },
      _active: {
        background: colors.colorB4,
      },
      '&:disabled': {
        opacity: '0.4',
        background: colors.colorA2Alpha10,
      },
    },
    yellowOutline: {
      pos: 'relative',
      background: colors.colorA1Alpha5,
      border: `1px solid ${colors.colorA1}`,
      color: colors.colorA1,
      // Use pseudo-element for border
      _after: {
        content: '""',
        position: 'absolute',
        right: '0',
        bottom: '0',
        // follow the polygon setting
        width: '6%',
        height: '30%',
        backgroundColor: colors.colorA1,
        clipPath: 'polygon(0 100%, 100% 0, 100% 100%)',
        pointerEvents: 'none',
      },
      _hover: {
        background: colors.colorA1,
        color: colors.colorB7,
      },
      _active: {
        background: colors.colorA2,
        color: colors.colorB7,
      },
    },
    'sold-gray': {
      background: colors.colorB5,
      color: colors.colorB1,
      _hover: {
        background: colors.hoverColor4,
      },
      _active: {
        background: colors.hoverColor4,
      },
      '&:disabled': {
        opacity: '0.4',
        background: colors.colorB5,
      },
    },
    'solid-black': {
      background: colors.colorB7,
      color: colors.colorA1,
      '&:disabled': {
        opacity: '0.4',
      },
    },
    'ghost-grayB4': {
      background: colors.colorB4,
      color: colors.colorB1,
      _hover: {
        background: colors.colorB4,
      },
      _active: {
        background: colors.colorB4,
      },
      '&:disabled': {
        opacity: 1,
        background: colors.colorB4,
      },
    },
    'ghost-green': {
      background: colors.color7Alpha5,
      color: colors.colorA2,
      clipPath: clippath.polygon,
      _hover: {
        background: colors.color7Alpha8,
      },
      _active: {
        background: colors.color7Alpha8,
      },
      '&:disabled': {
        opacity: '0.4',
        background: colors.color7Alpha5,
      },
    },
    'ghost-gray': {
      background: colors.color3Alpha5,
      color: colors.colorB3,
      clipPath: clippath.polygon,
      _hover: {
        background: colors.color3Alpha8,
        '&:disabled': {
          background: colors.color3Alpha5,
        },
      },
      _active: {
        background: colors.color3Alpha8,
      },
      '&:disabled': {
        opacity: '0.4',
        background: colors.color3Alpha5,
      },
    },
    'ghost-yellow': {
      background: colors.colorA1,
      color: colors.colorB7,
      clipPath: clippath.polygon,
      _hover: {
        opacity: '0.8',
      },
      _active: {
        opacity: '0.8',
      },
      '&:disabled': {
        opacity: '0.4',
        background: colors.colorA1,
        color: colors.colorB7,
      },
    },
    'ghost-greenA2': {
      background: colors.colorA2,
      color: colors.colorB7,
      clipPath: clippath.polygon,
      _hover: {
        opacity: '0.8',
      },
      _active: {
        opacity: '0.8',
      },
      '&:disabled': {
        opacity: '0.4',
        background: colors.colorA2,
        color: colors.colorB7,
      },
    },
    'ghost-redA3': {
      background: colors.colorA1,
      color: colors.colorB7,
      clipPath: clippathleft.polygon,
      _hover: {
        opacity: '0.8',
      },
      _active: {
        opacity: '0.8',
      },
      '&:disabled': {
        opacity: '0.4',
        background: colors.colorA3,
        color: colors.colorB7,
      },
    },
    icon: {
      background: 'none',
      w: 'fit-content',
      h: 'auto',
      minWidth: '0px',
      minHeight: '0px',
      color: colors.colorB2,
      pos: 'relative',
      _hover: {
        background: 'none',
        color: colors.colorB1,
      },
    },
    blueOutline: {
      pos: 'relative',
      background: colors.colorA4Alpha10,
      border: `1px solid ${colors.colorA4}`,
      color: colors.colorA4,
      // Use pseudo-element for border
      _after: {
        content: '""',
        position: 'absolute',
        right: '0',
        bottom: '0',
        // follow the polygon setting
        width: '6%',
        height: '30%',
        backgroundColor: colors.colorA4,
        clipPath: 'polygon(0 100%, 100% 0, 100% 100%)',
        pointerEvents: 'none',
      },
      _hover: {
        background: colors.colorA4,
        color: colors.colorB7,
      },
      _active: {
        background: colors.colorA4,
        color: colors.colorB7,
      },
    },
    blueSolid: {
      background: colors.colorA4,
      color: colors.colorB7,
      '&:disabled': {
        opacity: '0.4',

        _hover: {
          opacity: 0.4,
          background: colors.colorA4,
          color: colors.colorB7,
        },
      },
    },
  },
}
